import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.payProfileValidation = function () {
        const dictonary = {
            custom: {
                payGroup: {
                    required: () => t.t(dictEnum.LBL_PayGroup) + t.t(dictEnum.WARN_IsRequired)
                },
                payRate: {
                    required: () => t.t(dictEnum.LBL_Rate) + t.t(dictEnum.WARN_IsRequired),
                    max: () => t.t(dictEnum.MSG_InputLengthLimit) + 8
                },
                VCR: {
                    required: () => t.t(dictEnum.LBL_VCR) + t.t(dictEnum.WARN_IsRequired),
                    max_value: () => t.t(dictEnum.LBL_NumMax) + 100
                },
                VCE: {
                    required: () => t.t(dictEnum.LBL_VCE) + t.t(dictEnum.WARN_IsRequired),
                    max_value: () => t.t(dictEnum.LBL_NumMax) + 100
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/100000-Payroll/106000-PayProfile/106000-PayProfileValidation.js